export default (state = {}, action) => {
    switch (action.type) {
        case 'PAGE':
            return action.payload;
        default:
            return state;
    }
};
